/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Script_TitleInputs */

const en_salary_negotiate_script_title = /** @type {(inputs: Salary_Negotiate_Script_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Negotiation Script`)
};

const de_salary_negotiate_script_title = /** @type {(inputs: Salary_Negotiate_Script_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Verhandlungsskript`)
};

const fr_salary_negotiate_script_title = /** @type {(inputs: Salary_Negotiate_Script_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton script de négociation`)
};

const es_salary_negotiate_script_title = /** @type {(inputs: Salary_Negotiate_Script_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su guión de negociación`)
};

const it_salary_negotiate_script_title = /** @type {(inputs: Salary_Negotiate_Script_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo script di negoziazione`)
};

const nl_salary_negotiate_script_title = /** @type {(inputs: Salary_Negotiate_Script_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je onderhandelingsscript`)
};

const pl_salary_negotiate_script_title = /** @type {(inputs: Salary_Negotiate_Script_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój skrypt negocjacyjny`)
};

const fi_salary_negotiate_script_title = /** @type {(inputs: Salary_Negotiate_Script_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuvotteluskriptisi`)
};

const da_salary_negotiate_script_title = /** @type {(inputs: Salary_Negotiate_Script_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit forhandlingsscript`)
};

const sv_salary_negotiate_script_title = /** @type {(inputs: Salary_Negotiate_Script_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditt förhandlingsmanus`)
};

/**
* | output |
* | --- |
* | "Your Negotiation Script" |
*
* @param {Salary_Negotiate_Script_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_script_title = /** @type {((inputs?: Salary_Negotiate_Script_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Script_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_script_title(inputs)
	if (locale === "fr") return fr_salary_negotiate_script_title(inputs)
	if (locale === "es") return es_salary_negotiate_script_title(inputs)
	if (locale === "it") return it_salary_negotiate_script_title(inputs)
	if (locale === "nl") return nl_salary_negotiate_script_title(inputs)
	if (locale === "pl") return pl_salary_negotiate_script_title(inputs)
	if (locale === "fi") return fi_salary_negotiate_script_title(inputs)
	if (locale === "da") return da_salary_negotiate_script_title(inputs)
	if (locale === "sv") return sv_salary_negotiate_script_title(inputs)
	return en_salary_negotiate_script_title(inputs)
});